var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs3/core-js/json/stringify", "@babel/runtime-corejs3/core-js/url", "@babel/runtime-corejs3/core-js/date/now", "../utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs3/core-js/json/stringify"), require("@babel/runtime-corejs3/core-js/url"), require("@babel/runtime-corejs3/core-js/date/now"), require("../utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.stringify, global.url, global.now, global.utils);
    global.fetch = mod.exports;
  }
})(this, function (_exports, _stringify, _url, _now, _utils) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = patchFetch;
  _stringify = _interopRequireDefault(_stringify);
  _url = _interopRequireDefault(_url);
  _now = _interopRequireDefault(_now);
  var orgFetch = window.fetch;
  /**
   * 创建fetch的proxy
   */

  function patchFetch() {
    var requestAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _utils.noop;
    var responseAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils.noop;
    if (!orgFetch) return;
    var me = this;

    var _$get = _utils._.get(me, ['config', 'record'], {}),
        interfaceRecordConfig = _$get.api_report_config;

    var withBody = interfaceRecordConfig.withBody,
        withResp = interfaceRecordConfig.withResp,
        reportFilter = interfaceRecordConfig.reportFilter,
        sampleRate = interfaceRecordConfig.sampleRate,
        enable = interfaceRecordConfig.enable;

    window.fetch = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var start = (0, _now.default)();
      var method = 'GET';

      if (args[1] && args[1].method) {
        method = args[1].method.toUpperCase();
      }

      var url = args[0] instanceof _url.default ? args[0].origin : typeof args[0] === 'string' ? args[0].split('?')[0] : args[0];
      requestAction({
        type: 'api',
        timestamp: start,
        method: method,
        url: url
      });
      return orgFetch.apply(this, args).then(function (res) {
        var resClone = res.clone();

        try {
          var end = (0, _now.default)();
          var spend = end - start;
          var manifest = (res.url || args[0]).split('?');
          var reqUrl = manifest[0];
          var param = manifest[1] || '';
          var pJSON = '';

          if (method !== 'GET' && args[1] && args[1].body) {
            pJSON = (0, _stringify.default)(args[1].body);
          }

          res.clone().text().then(function (stdout) {
            stdout = stdout || '';
            var hasObj = true;
            var result = {};

            if (typeof reportFilter === 'function') {
              hasObj = !!(result = reportFilter.call(resClone, {
                url: reqUrl,
                status: res.status,
                response: stdout
              }));
            } // me.debugLogger('Fetch Filter\u6267\u884c\u7ed3\u679c\uff1a', result)


            stdout = stdout.length > 1024 ? (0, _utils.stringSlice)(stdout, 996, '[response content too large]') : stdout;
            var report = enable && (0, _utils.canReport)(sampleRate);

            if (!report) {
              responseAction({
                timestamp: end,
                spend: spend,
                method: method,
                url: reqUrl,
                status: res.status,
                message: result.msg || res.statusText || ''
              }); // me.debugLogger('Fetch监测未打开或未命中抽样', enable, report)

              return;
            }

            if (hasObj && spend < 121E3) {
              var status = result.bizCode || res.status;
              var needReport = (0, _utils.ifReportHttpError)(status, reqUrl);
              me.interface(30001, {
                error_no: "API_Fetch",
                url: reqUrl,
                method: method,
                http_code: res.status,
                biz_code: result.bizCode === undefined ? status : result.bizCode,
                during_ms: spend
              }, {
                param: param,
                msg: result.msg || res.statusText || '',
                body: needReport && withBody ? pJSON : '',
                resp: needReport && withResp ? (0, _utils.stringSlice)(result.resp, 996, '[response content too large]') || stdout : ''
              });
            }
          });
          responseAction({
            timestamp: end,
            spend: spend,
            method: method,
            url: reqUrl,
            status: res.status,
            message: res.message || res.msg || res.statusText || ''
          });
        } catch (msg) {}

        return res;
      }).catch(function (e) {
        var end = (0, _now.default)();
        responseAction({
          timestamp: end,
          spend: end - start,
          method: method,
          url: args[0].split('?')[0],
          status: 0,
          message: e.message || e.stack || '未知'
        });
        throw e;
      });
    };
  }
});